import { removeLocalStorage } from '@/utils/common/storage'

import { api } from '@/services'
import { useUserStore } from '@/stores/user.stores'
import { useI18n } from 'vue-i18n'
import { useNotification } from '@/composables/useNotification'
import { catchErrorHandler } from '@/utils/api/error-handler'
import { errorMessagesMapping } from '@/constants/mappings/errorMessages.mapping'
import { FROM_THIRD_PARTY_ID, FROM_THIRD_PARTY_TYPE } from '@/constants/storageKey.const'

/** Google 登入 */
export const useGoogleAuth = () => {
  const { t: $t } = useI18n()
  const { openNotification } = useNotification()
  const userStore = useUserStore()

  // 初始化第三方存儲
  const initializeThirdPartyStorage = () => {
    // 第三方登入來源只在當次流程有效，結束後就清空
    removeLocalStorage(FROM_THIRD_PARTY_ID)
    removeLocalStorage(FROM_THIRD_PARTY_TYPE)
  }

  // 呼叫後端 API 進行登入
  const loginWithGoogle = async (credential: string): Promise<boolean> => {
    try {
      const { result, isSuccess, resultCode } = await api.auth.googleLogIn({ credential })

      if (!isSuccess) {
        if (!resultCode) {
          return false
        }

        // 失敗：顯示錯誤訊息提示
        openNotification(
          {
            title: $t('Common.Response.Error'),
            subTitle: $t(`ServerResponse.ResultCode.${resultCode}`)
          },
          'error'
        )
        return false
      }

      // Google 登入成功後仍走一般 token 流程
      userStore.token = result.token
      return true
    } catch (e) {
      catchErrorHandler(e)
      return false
    }
  }

  return {
    initializeThirdPartyStorage,
    loginWithGoogle
  }
}
